import CheckoutTemplate1 from "./CheckoutTemplate1";
import CheckoutTemplate2 from "./CheckoutTemplate2";
import CheckoutTemplate3 from "./CheckoutTemplate3";
import CheckoutTemplate4 from "./CheckoutTemplate4";
import CheckoutTemplate5 from "./CheckoutTemplate5";
import CheckoutTemplate6 from "./CheckoutTemplate6";
import CheckoutTemplate7 from "./CheckoutTemplate7";
import CheckoutTemplate8 from "./CheckoutTemplate8";
import CheckoutTemplate9 from "./CheckoutTemplate9";
import CheckoutTemplate10 from "./CheckoutTemplate10";
import CheckoutTemplate11 from "./CheckoutTemplate11";
import CheckoutTemplate12 from "./CheckoutTemplate12";
import CheckoutTemplate13 from "./CheckoutTemplate13";
import CheckoutTemplate14 from "./CheckoutTemplate14";
import CheckoutTemplate15 from "./CheckoutTemplate15";
import CheckoutTemplate16 from "./CheckoutTemplate16";
import CheckoutTemplate17 from "./CheckoutTemplate17";

// template_id (1-17) → checkout component, matching the sales template design.
// Unknown ids fall back to template 1.
export const CHECKOUT_TEMPLATES = {
  1: CheckoutTemplate1,
  2: CheckoutTemplate2,
  3: CheckoutTemplate3,
  4: CheckoutTemplate4,
  5: CheckoutTemplate5,
  6: CheckoutTemplate6,
  7: CheckoutTemplate7,
  8: CheckoutTemplate8,
  9: CheckoutTemplate9,
  10: CheckoutTemplate10,
  11: CheckoutTemplate11,
  12: CheckoutTemplate12,
  13: CheckoutTemplate13,
  14: CheckoutTemplate14,
  15: CheckoutTemplate15,
  16: CheckoutTemplate16,
  17: CheckoutTemplate17,
};

export function checkoutTemplateFor(id) {
  return CHECKOUT_TEMPLATES[Number(id)] || CHECKOUT_TEMPLATES[1];
}
